export const isCreateIndividualObligationResponse = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const o = value.obligation;
    return (typeof o?.id === 'string' &&
        typeof o.member?.id === 'string' &&
        typeof o.concept?.id === 'string' &&
        /^\d{4}-\d{2}$/.test(o.period ?? '') &&
        typeof o.amount === 'string' &&
        o.currency === 'USD' &&
        o.state === 'confirmed' &&
        typeof o.origin?.actId === 'string' &&
        typeof o.confirmedAt === 'string');
};
